module.exports = __webpack_public_path__ + "img/阴险.94d8a748.png";